module.exports = __webpack_public_path__ + "files/fd9bd349a9b0a4466a1ab3c9442873af.png";